'use client';

import {
	Stack,
	Text,
} from '@chakra-ui/react';

import type { JobOccupationStep } from '@/modules/authentication/view-model';
import { useOccupationCollections, useOccupationFormWatch } from '@/modules/shared';

import { Form } from '@packages/hook-form-wrapper';

export const JobOccupation = () => {
	const {
		categoryId,
		subCategoryId,

		category,
		specialization,
		subCategory,
	} = useOccupationFormWatch<JobOccupationStep>();
	const {
		categoryCollection,
		specializationCollection,
		subCategoryCollection,
	} = useOccupationCollections(categoryId, subCategoryId);

	return (
		<Stack gap="md">
			<Text textStyle="bodyBold">Occupation</Text>
			<Form.SelectInput
				collection={categoryCollection}
				label="Category"
				name={category.name}
				placeholder="Category"
			/>
			<Form.SelectInput
				collection={subCategoryCollection}
				disabled={subCategory.disabled}
				label="Subcategory"
				name={subCategory.name}
				placeholder="Subcategory"
			/>
			<Form.SelectInput
				collection={specializationCollection}
				disabled={specialization.disabled}
				label="Specialization"
				name={specialization.name}
				placeholder="Specialization"
			/>
		</Stack>
	);
};
